module.exports = __webpack_public_path__ + "static/media/twitter-logo.704704af.png";